/*
 * Main script
 *
 * This is where we initialize all global scripts
 * Please refrain from writing any actual code in this file, other than inits
 */

/*!

Energi Danmark 2016

Proud authors:      www.novicell.dk
People behind:      Lars Hesselberg, @hesselberg

!*/

var novicell = novicell || {};
var svg4everybody = svg4everybody || {};
var ed = ed || {};

// Document ready
$(function () {
    // Novicell
    novicell.responsiveLazyloadImage.onLoad();
    novicell.cookieInfo.init();

    // Base
    ed.video.init();
    ed.slideshow.init();
    ed.tabs.init();
    ed.forms.init();

    // Global components
    ed.pageHeader.init();
    ed.siteSearch.init();
    ed.siteSelector.init();
    ed.siteNavigation.init();

    // Block specific components
    ed.productsServices.init();
    ed.newsStream.init();
    ed.marketGraph.init();
    ed.newsletter.init();
    ed.riskModel.init();

    // 3rd party
    svg4everybody(); // Fix SVG spritemap in IE/Edge
});

// Window load
$(window).load(function(e){
     ed.employeeList.init();
     ed.pageHeader.video();
});

// Window resize (debounced)
$(window).smartresize(function(e){
    novicell.responsiveLazyloadImage.onResize();
    ed.siteSelector.place();
    ed.siteNavigation.place();
    ed.references.activateSlideshow();
    ed.pageHeader.videoMobile();
});

// Window scroll (debounced)
$(window).smartscroll(function(e){
    // do stuff as soon as the user stops scrolling for longer than 100ms
    if ($('.responsiveLazyload').length) {
        novicell.responsiveLazyloadImage.onScroll();
    }
});